import { fetchUsersBegin, fetchUsersSuccess, fetchUsersFailure, fetchSearchSuccess, fetchSearchSuccessHome } from './actions';
//import produk_hukum from '../files/hukum.json';

export function fetchUsers(data) {
    return dispatch => {
        dispatch(fetchUsersBegin());
        dispatch(fetchUsersSuccess(data));
    };
}

export function fetchSearch(data) {
    return dispatch => {
        dispatch(fetchUsersBegin());
        dispatch(fetchSearchSuccess(data));
    };
}

export function fetchSearchHome(data) {
    return dispatch => {
        dispatch(fetchUsersBegin());
        dispatch(fetchSearchSuccessHome(data));
    };
}

// Helper function for error handling
function handleErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}